/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountStatusHistoryEntry
 */
export interface AccountStatusHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof AccountStatusHistoryEntry
     */
    action: AccountStatusHistoryEntryActionEnum;
    /**
     * Admin who performed it. Absent when the player disabled their own account.
     * @type {string}
     * @memberof AccountStatusHistoryEntry
     */
    by?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStatusHistoryEntry
     */
    at: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStatusHistoryEntry
     */
    reason: string;
}


/**
 * @export
 */
export const AccountStatusHistoryEntryActionEnum = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
} as const;
export type AccountStatusHistoryEntryActionEnum = typeof AccountStatusHistoryEntryActionEnum[keyof typeof AccountStatusHistoryEntryActionEnum];


/**
 * Check if a given object implements the AccountStatusHistoryEntry interface.
 */
export function instanceOfAccountStatusHistoryEntry(value: object): value is AccountStatusHistoryEntry {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('at' in value) || value['at'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AccountStatusHistoryEntryFromJSON(json: any): AccountStatusHistoryEntry {
    return AccountStatusHistoryEntryFromJSONTyped(json, false);
}

export function AccountStatusHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountStatusHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'by': json['by'] == null ? undefined : json['by'],
        'at': json['at'],
        'reason': json['reason'],
    };
}

export function AccountStatusHistoryEntryToJSON(json: any): AccountStatusHistoryEntry {
    return AccountStatusHistoryEntryToJSONTyped(json, false);
}

export function AccountStatusHistoryEntryToJSONTyped(value?: AccountStatusHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'by': value['by'],
        'at': value['at'],
        'reason': value['reason'],
    };
}

